import { DEFAULT_NOTIFICATION_SENT_FILTER } from 'constants/common'
import NotificationRequestTypes from 'store/actionTypes/notificationRequest'
import UserTypes from 'store/actionTypes/user'

const initialData = {
  listRequest: [],
  listSent: [],
  pagination: {},
  notificationRequestFilter: {},
  notificationSentFilter: DEFAULT_NOTIFICATION_SENT_FILTER
}

const notificationRequest = (state = initialData, action = {}) => {
  const { payload } = action
  switch (action.type) {
    case NotificationRequestTypes.GET_LIST_NOTIFICATION_REQUEST_SUCCESS:
      return {
        ...state,
        listRequest: payload?.items,
        pagination: payload?.meta
      }
    case NotificationRequestTypes.GET_LIST_NOTIFICATION_SENT_SUCCESS:
      return { ...state, listSent: payload?.items }
    case NotificationRequestTypes.UPDATE_FILTER_NOTIFICATION_REQUEST_SUCCESS:
      return { ...state, notificationRequestFilter: payload }
    case NotificationRequestTypes.CLEAR_FILTER_NOTIFICATION_REQUEST_SUCCESS:
      return {
        ...state,
        notificationRequestFilter: initialData.notificationRequestFilter
      }
    case NotificationRequestTypes.UPDATE_FILTER_NOTIFICATION_SENT_SUCCESS:
      return { ...state, notificationSentFilter: payload }
    case NotificationRequestTypes.CLEAR_FILTER_NOTIFICATION_SENT_SUCCESS:
      return {
        ...state,
        notificationSentFilter: initialData.notificationSentFilter
      }
    case UserTypes.LOGOUT_SUCCESS:
      return initialData
    default:
      return state
  }
}

export default notificationRequest
